import React, { Suspense } from "react";
import { Spin } from "antd";
import { createFileRoute, Navigate, Outlet, redirect } from "@tanstack/react-router";

import useUser from "/src/stores/useUser";
import ResetPassword404 from "/src/routes/errors/resetPassword404/ResetPassword404";
import { resolveAuthenticatedUserRedirect } from "/src/routes/login/login-success-redirect";

export const Route = createFileRoute("/user")({
  beforeLoad: () => {
    const user = useUser.getState().user;
    if (user.access_token) {
      throw redirect({ to: resolveAuthenticatedUserRedirect(user) as any });
    }
  },
  component: UserLayout,
});

function UserLayout() {
  // Subscribe so a successful login (zustand update) re-renders and redirects,
  // matching the pre-TanStack UserLayout behavior. beforeLoad alone does not
  // re-run when the auth store changes while already on /user/login.
  const user = useUser((state) => state.user);

  if (user.access_token) {
    return <Navigate to={resolveAuthenticatedUserRedirect(user) as any} replace />;
  }

  if (window.location.href.includes("resetPassword")) {
    return (
      <Suspense fallback={<Spin />}>
        <ResetPassword404 />
      </Suspense>
    );
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Spin />}>
        <Outlet />
      </Suspense>
    </React.Fragment>
  );
}
